import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { RouterProvider } from '@tanstack/react-router';
import { router, queryClient } from '@/lib';
import { RegisterAuth } from '@carvana/core-auth';
import { getEnvironment, isDevelopment } from '@/utils';

import './ds-imports.css';
import './global.css';

RegisterAuth({
  environment: getEnvironment(),
  setupFetch: true,
});

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <QueryClientProvider client={queryClient}>
    <RouterProvider router={router} />
    {isDevelopment && <ReactQueryDevtools initialIsOpen={false} />}
  </QueryClientProvider>
);
